export default __webpack_public_path__ + "banner-card-icon311729f.png";